import useSWR, { type SWRConfiguration } from 'swr';

import { buildQueryKey } from '@common/utils/buildQueryKey';

import {
  getMatchmakerRecommendations,
  type GetMatchmakerRecommendationsParams,
  type GetMatchmakerRecommendationsResponse,
} from '@services/MatchmakerService';

export type UseGetMatchmakerRecommendationsParams = {
  isEnabled: boolean;
  queryParams?: GetMatchmakerRecommendationsParams;
  swrOptions?: SWRConfiguration<GetMatchmakerRecommendationsResponse, unknown>;
};

export const getMatchmakerRecommendationsQueryKey = (
  queryParams?: GetMatchmakerRecommendationsParams,
) => buildQueryKey('get-matchmaker-recommendations', queryParams);

export const useGetMatchmakerRecommendations = ({
  isEnabled,
  queryParams,
  swrOptions,
}: UseGetMatchmakerRecommendationsParams) => {
  const { data, ...swrResponse } = useSWR<GetMatchmakerRecommendationsResponse>(
    isEnabled ? getMatchmakerRecommendationsQueryKey(queryParams) : null,
    () => getMatchmakerRecommendations(queryParams),
    swrOptions,
  );

  return {
    data,
    ...swrResponse,
  };
};
